import res2016 from "./2016.json";
import res2017 from "./2017.json";
import res2018 from "./2018.json";
import res2019 from "./2019.json";
import res2020 from "./2020.json";

export default [res2016, res2017, res2018, res2019, res2020];
